import { Component } from '@angular/core';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrl: './logo.component.css',
    host: {
        role: 'img',
        'aria-label': 'Ochnik — Panel administracyjny',
    },
})
export class LogoComponent {}
